// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__292D3","colBig":"styles_colBig__U3JRv","colSmall":"styles_colSmall__25_S6"};